var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-sex"},[_c('div',{staticClass:"title"},[_vm._v("笔单价：")]),_c('div',{staticClass:"tip"},[_vm._v("客户累计支付金额/累计支付笔数，支付成功即计入，不剔除退款")]),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"flex"},[_c('num-mod',{ref:"numMod",attrs:{"disabled":_vm.disabled,"txt":"元","precision":2}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }